/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function slider() {
  var slider = document.querySelector('.slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    prevNextButtons: false
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
